module.exports = __webpack_public_path__ + "img/free.877ca39b.jpg";